<template>
  <bm-number
    v-bind="$attrs"
    :min="min"
    :max="max"
    :suffix="suffix"
    :value="value"
    @input="$emit('input', $event)"
  ></bm-number>
</template>

<script lang="ts">
import { defineComponent } from "vue";
export default defineComponent({
  name: "BmPercentage",
  props: {
    value: {
      type: Number,
      required: false,
    },
    min: {
      type: Number,
      default: 0,
    },
    max: {
      type: Number,
      default: 100,
    },
    suffix: {
      type: String,
      default: "%",
    },
  },
});
</script>
